import gql from 'graphql-tag';
import { ECHELON_INFO_FRAGMENT } from './fragment';

export const GET_ECHELON = gql`
  query GetEchelon($input: GetEchelonInput!) {
    getEchelon(input: $input) {
      ...EchelonInfo
    }
  }
  ${ECHELON_INFO_FRAGMENT}
`;

export const GET_ALL_ECHELONS = gql`
  query GetAllEchelons($input: GetAllEchelonsInput) {
    getAllEchelons(input: $input) {
      ...EchelonInfo
    }
  }
  ${ECHELON_INFO_FRAGMENT}
`;
